/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_RetryInputs */

const en_brand_retry = /** @type {(inputs: Brand_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const id_brand_retry = /** @type {(inputs: Brand_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba lagi`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Brand_RetryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const brand_retry = /** @type {((inputs?: Brand_RetryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_RetryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brand_retry(inputs)
	return en_brand_retry(inputs)
});